import ConfirmFrame from './ConfirmFrame.vue';

export default ConfirmFrame;
